import React from 'react';
import Moment from 'react-moment';
import { useTranslation } from 'react-i18next';
import {
  Card,
  CardHeader,
  CardContent,
  CardFooter,
} from '@/components/ui/card';
import { Heading } from '@/components/ui/shared/heading';
import { Button } from '@/components/ui/button';

export const VisitPaymentVisitDetails = ({ visitDetails }) => {
  const { t } = useTranslation();

  const handleCancel = () => {
    if (visitDetails.cancelationUrl) {
      window.location.href = visitDetails.cancelationUrl;
    }
  };

  return (
    <div className="space-y-4">
      <Card>
        <CardHeader>
          <Heading variant="userAccountDetailsTitle">
            {t('userAccount.visitTab.visitInfo')}
          </Heading>
        </CardHeader>

        <CardContent className="space-y-2">
          {/* Medical center */}
          <div>
            <span>{t('userAccount.visitTab.medicalCenter')} </span>
            <span>{visitDetails.location}</span>
          </div>

          {/* Date */}
          <div>
            <span>{t('userAccount.visitTab.date')} </span>
            <span>
              {new Date(visitDetails.date).getUTCHours() === 0 ? (
                <Moment utc format="YYYY-MM-DD">
                  {visitDetails.date}
                </Moment>
              ) : (
                <Moment utc format="YYYY-MM-DD HH:mm">
                  {visitDetails.date}
                </Moment>
              )}
            </span>
          </div>
        </CardContent>

        <CardFooter>
          {(!!visitDetails.paymentUrl || !!visitDetails.cancelationUrl) && (
            <div
              className="
                flex flex-col space-y-2
                sm:flex-row sm:space-y-0 sm:space-x-2
              "
            >
              {!!visitDetails.cancelationUrl && (
                <Button variant="outline" onClick={handleCancel}>
                  {t('Atšaukti užsakymą')}
                </Button>
              )}

              {!!visitDetails.paymentUrl && (
                <Button asChild>
                  <a href={visitDetails.paymentUrl}>{t('Apmokėti užsakymą')}</a>
                </Button>
              )}
            </div>
          )}
        </CardFooter>
      </Card>
    </div>
  );
};
